export const createAnalyticsCardHeader = (reportDefinition, activeColumn) => ({
    label: reportDefinition?.name || '',
    tooltip: activeColumn?.tooltip
        ? {
            title: activeColumn.tooltip.title,
            description: activeColumn.tooltip.description,
            type: activeColumn.tooltip.formatType,
        }
        : undefined,
});
